import { inject } from '@angular/core';
import { from, of, switchMap, throwError } from 'rxjs';
import { HttpInterceptorFn } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { environment } from '@env/environment';
import { AppDocumentService } from '@core/shared/services';
import { RecaptchaProviderService } from '@core/shared/providers';
import { PATH_PUBLIC } from '@data/constants';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const route = inject(ActivatedRoute);
  const document = inject(AppDocumentService);
  const recaptchaService = inject(RecaptchaProviderService);
  const auxPath = document.pathName()?.split('/');
  const hasXPath = req?.headers?.has(PATH_PUBLIC);

  let url = `${environment.apiPath}${req.url}`;

  const headers: Record<string, string> = {
    'x-application': 'smart-mobility',
    'x-role': 'tecnico',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  };

  const isPublic = auxPath?.at(1) === 'public';

  if (isPublic) {
    headers['x-key'] = environment.apiKeyPublicAccess;
    headers['x-user'] =
      route.snapshot.queryParams?.['x'] || environment.publicTypeUser.CUSTOMER;

    if (!hasXPath) {
      url = url.replace('/api', '/api/public');
    }
  }

  return of(isPublic).pipe(
    switchMap((isPublicPath) => {
      if (!isPublicPath) {
        return next(
          req.clone({
            setHeaders: headers,
            url,
          }),
        );
      }

      return from(recaptchaService.getRecaptcha('smart_public_action')).pipe(
        switchMap((resp) => {
          if (!resp.success) {
            return throwError(() => new Error(resp.message));
          }

          return next(
            req.clone({
              setHeaders: {
                ...headers,
                ...resp.data,
              },
              url,
            }),
          );
        }),
      );
    }),
  );
};
